import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=9a8f24f4&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=9a8f24f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8f24f4",
  null
  
)

export default component.exports